import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import { GOLD } from '@propertypal/shared/src/styles/theme';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 10px;
  background-color: ${({ theme }) => theme.background};
  border: 2px solid ${({ theme }) => theme.keyline};
  padding: 20px;
  color: ${({ theme }) => theme.textDark};
  display: flex;
  gap: 30px;
  justify-content: space-between;

  & > div {
    flex: 1;
  }

  h3 {
    font-family: ${platform.headingFont};
    font-size: 24px;

    b {
      color: ${GOLD};
    }
  }

  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 480px;
  padding-right: 40px;
  padding-top: 22px;
  display: flex;

  img {
    width: 100%;
    height: auto;
  }

  @media (${laptopMediumMax}) {
    justify-content: flex-start;
  }
`;

export const Banner = styled.div`
  background-color: #f8edda;
  border-radius: 10px 10px 0 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 200px;
  height: 40px;
  padding: 5px;
  text-align: center;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (${mobileXXLargeMax}) {
    display: none;
  }
`;

export const CheckRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 15px 0;

  svg {
    margin-top: 2px;
    margin-right: 5px;
  }
`;

export const Badge = styled.div`
  background: ${GOLD};
  color: ${({ theme }) => theme.white};
  border-radius: 140px;
  width: 140px;
  height: 140px;
  padding: 10px;
  position: absolute;
  top: -10px;
  right: -10px;
  display: flex;
  align-items: center;

  p {
    font-family: ${platform.headingFont};
    line-height: 1.1;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
  }

  span {
    font-size: 24px;
    color: #f8edda;
  }
`;
